/**
 * @packageDocumentation
 * @module f1/adt
 */

import { t_rec_open } from '../types';

export interface Assign {
  /**
   * Returns a new object and assigns `assign` to `object`.
   *
   * @public
   * @function f1.assign
   * @param base
   * @param overwrite
   * @example
   *
   * ```ts
   * assign({
   *   name: 'Yoda',
   *   age: 900
   * }, {
   *   id: 1,
   *   age: 100
   * }) === { id: 1, name: 'Yoda', age:900 }
   * ```
   */
  <B extends t_rec_open, O extends t_rec_open>(base: B, overwrite: O): B & O;
  /**
   * {@link FnAssignValue}
   * @param base
   */
  <B extends t_rec_open, O extends t_rec_open>(base: B): (overwrite: O) => B & O;
}

/**
 * @see Assign
 */
export default <B extends t_rec_open, O extends t_rec_open>(base: B, overwrite: O): B & O => ({
  ...base,
  ...overwrite
});
